import { useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Lock, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getToken = () => localStorage.getItem('admin_token');

export default function AdminChangePassword() {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(false);
    if (form.new_password !== form.confirm_password) { setError('Passwords do not match'); return; }
    if (form.new_password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/admin/change-password`, {
        current_password: form.current_password,
        new_password: form.new_password,
      }, { headers: { Authorization: `Bearer ${getToken()}` } });
      setSuccess(true);
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change password');
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-change-password">
      <h1 className="font-heading text-2xl font-medium mb-8">Change Password</h1>
      <Card className="rounded-2xl border-border max-w-md">
        <CardContent className="p-6">
          {success && (
            <div className="flex items-center gap-2 text-primary mb-4 p-3 bg-primary/5 rounded-xl" data-testid="password-success">
              <CheckCircle className="w-5 h-5" /> Password changed successfully!
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-sm">Current Password</Label>
              <Input type="password" value={form.current_password} onChange={e => setForm({...form, current_password: e.target.value})} required className="mt-1 rounded-xl" data-testid="current-password" />
            </div>
            <div>
              <Label className="text-sm">New Password</Label>
              <Input type="password" value={form.new_password} onChange={e => setForm({...form, new_password: e.target.value})} required className="mt-1 rounded-xl" data-testid="new-password" />
            </div>
            <div>
              <Label className="text-sm">Confirm New Password</Label>
              <Input type="password" value={form.confirm_password} onChange={e => setForm({...form, confirm_password: e.target.value})} required className="mt-1 rounded-xl" data-testid="confirm-password" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="password-error">{error}</p>}
            <Button type="submit" disabled={saving} className="w-full rounded-xl" data-testid="change-password-btn">
              {saving ? 'Changing...' : <><Lock className="w-4 h-4 mr-2" /> Change Password</>}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
